import {goto} from "$app/navigation";
import {page} from "$app/stores";

export let searchParams = {
    set(key: string, value: string) {

    },
    delete(key: string){}
}

if(typeof document !== 'undefined'){
    searchParams = new URL(document.location.href).searchParams
}
export const handleSort = async (ev: any, pageData: any, url:string) => {
    if(typeof document !== 'undefined'){
        searchParams = new URL(document.location.href).searchParams
    }
    pageData.sort = ev.detail.property;
    pageData.order = ev.detail.order < 0 ? 'desc' : 'asc';
    pageData.page = 1;
    searchParams.set('sort', pageData.sort)
    searchParams.set('order', pageData.order)
    searchParams.set('pageSize', pageData.pageSize)
    searchParams.set('page', pageData.page)
    await goto(url + '?' + searchParams.toString())

}

export const setFilter = async (filterName: string, filterValue: string, pageData: any, url:string) => {
    if(filterValue === ''){
        searchParams.delete(filterName)
        delete pageData[`filter[${filterName}]`]
    } else {
        searchParams.set(`filter[${filterName}]`, filterValue)
        pageData[`filter[${filterName}]`] = filterValue
    }

    await goto(url + '?' + searchParams.toString())
}